import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import { canViewPricingData } from 'helpers/permissions';
import { useAppSelector } from 'store/hook';

const Overview = () => {
  const navigate = useNavigate();

  const { selectedCommunity } = useAppSelector((state) => state.global);
  const { currentUser } = useAppSelector((state) => state.auth);
  const showPricingData = canViewPricingData(currentUser);
  const canUseAICompetitiveIntelligence = Boolean(currentUser?.feature_flags?.show_ai_competitive_intelligence);

  if (selectedCommunity) {
    navigate(`/communities/${selectedCommunity.id}`);
  } else if (!showPricingData && canUseAICompetitiveIntelligence) {
    navigate('/ai-competitive-intelligence');
  }

  return <Outlet />;
};

export default Overview;
